import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CreatePolicy from "./CreatePolicy";

const CreatePolicyLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create/Edit Policy" />
      <CreatePolicy />
    </MasterLayout>
  );
};

export default CreatePolicyLayout;
